import { useEffect, useState } from 'react'
import * as api from '../api/account'
import { useAuth } from '../context/AuthContext'

/**
 * Ustawienia wyceny zalogowanej firmy albo `null`.
 *
 * `null` znaczy „licz tak jak dotąd" i jest stanem dla gościa, konta prywatnego
 * oraz dla firmy w trakcie wczytywania. To celowe: dopóki nie wiemy, jakie ma
 * stawki, pokazujemy nasze domyślne, a nie pustkę ani migającą kwotę.
 *
 * Odpowiedź trzymamy w pamięci MODUŁU, nie komponentu. Rachunek zestawu pojawia
 * się na jednym ekranie wielokrotnie (karta w asystencie, potwierdzenie, okno
 * projektu), a każde z tych miejsc pytałoby osobno o te same ustawienia.
 */

let zapamietane = null
let wTrakcie = null

/** Po zapisie ustawień: kolejne otwarcie dokumentu ma widzieć nowe logo, kolor i stawki od razu. */
export const zapamietajUstawieniaWyceny = (dane) => { zapamietane = dane }

const useUstawieniaWyceny = () => {
  const { isAuthenticated, firmowe } = useAuth()
  const [ustawienia, setUstawienia] = useState(zapamietane)

  useEffect(() => {
    if (!isAuthenticated || !firmowe) {
      setUstawienia(null)
      return undefined
    }
    if (zapamietane) { setUstawienia(zapamietane); return undefined }

    let anulowane = false
    wTrakcie = wTrakcie || api.getQuoteSettings()
    wTrakcie.then((res) => {
      if (res.ok) zapamietane = res.data
      wTrakcie = null
      if (!anulowane) setUstawienia(res.ok ? res.data : null)
    })
    return () => { anulowane = true }
  }, [isAuthenticated, firmowe])

  return ustawienia
}

export default useUstawieniaWyceny
